import { getCurrencySymbol } from '@angular/common';
import { DEFAULT_CURRENCY_CODE, Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ShortNumberService {
  private readonly currencyCode = inject(DEFAULT_CURRENCY_CODE);

  public abbrieviate(value: number | null | undefined, fixed = 0, isCurrency = false): string {
    const formattedValue = this.abbreviateNumber(value ?? 0, fixed);

    return isCurrency ? this.addCurrency(formattedValue) : formattedValue;
  }

  private addCurrency(value: string): string {
    return `${getCurrencySymbol(this.currencyCode, 'narrow')}${value}`;
  }

  private abbreviateNumber(num: number, fixed = 1, padding = false): string {
    const NUM_SIGNIFICANT_FIGURES = 3;
    const symbols = ['', 'k', 'm', 'b', 't', 'p', 'e'];
    const negativePrefix = Math.sign(num) >= 0 ? '' : '-';
    const value = Math.abs(num);
    const symbolIndex = value > 0 ? Math.trunc(Math.log10(value) / NUM_SIGNIFICANT_FIGURES) : 0;

    if (symbolIndex === 0) {
      return `${negativePrefix}${value.toString()}`;
    }

    let suffix = symbols[symbolIndex];

    if (!suffix) {
      throw new RangeError(`Suffix index ${symbolIndex} could not be found for the short number pipe`);
    }

    const scale = Math.pow(10, symbolIndex * NUM_SIGNIFICANT_FIGURES);

    const scaled = value / scale;

    let rounded = !padding ? Number(scaled.toFixed(fixed)) : Number(scaled.toFixed(fixed));

    // Handle cases where the rounding should cause the suffix to move up to the next symbol e.g. 999,999 getting rounded to 1000k instead of 1m
    if (rounded === Math.pow(10, NUM_SIGNIFICANT_FIGURES)) {
      suffix = symbols[symbolIndex + 1];

      if (!suffix) {
        throw new RangeError(`Suffix index ${symbolIndex} could not be found for the short number pipe`);
      }

      rounded = rounded / Math.pow(10, NUM_SIGNIFICANT_FIGURES);
    }

    return `${negativePrefix}${rounded}${suffix}`;
  }
}
